import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DRLogo from '../Assets/Images/DR_Logo.png';
import REDLogo from '../Assets/Images/RED_Logo.png';
import Background_Main from '../Assets/Images/NSDAPS_Main_Facade.jpg';
import Background_Annex from '../Assets/Images/NSDAPS_Annex_Facade.jpg';
import Slideshow_1 from '../Assets/Images/Slideshow/1.jpg';
import Slideshow_2 from '../Assets/Images/Slideshow/2.jpg';
import Slideshow_3 from '../Assets/Images/Slideshow/3.jpg';
import Slideshow_4 from '../Assets/Images/Slideshow/4.jpg';
import Slideshow_5 from '../Assets/Images/Slideshow/5.jpg';
import Slideshow_6 from '../Assets/Images/Slideshow/6.jpg';
import Slideshow_7 from '../Assets/Images/Slideshow/7.jpg';
import Slideshow_8 from '../Assets/Images/Slideshow/8.jpg';
import Slideshow_9 from '../Assets/Images/Slideshow/9.jpg';
import Slideshow_10 from '../Assets/Images/Slideshow/10.jpg';
import Slideshow_11 from '../Assets/Images/Slideshow/11.jpg';
import FormLandingLogin from '../components/LoginRegister/Form_Landing_LogIn';
import FormLandingRegister from '../components/LoginRegister/Form_Landing_Register';
// import Test_Rooms_List from '../components/Test_Rooms_List';
import UISubwindows from '../components/UI_Subwindows';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import { Context_UI } from '../Contexts/Context_UI';
import Subwindow_Modal_Register_RequestSent from '../components/Subwindow_Modal_Register_RequestSent';
import UI_Horizontal_Tabs from '../components/ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../components/ERUMAUI/UI_Icons';



export default function Rooms_Page() {
    const UI = useContext(Context_UI);
    const [Loading, Loading_Set] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        UI.Page_Navigator_Set(navigate);
        setTimeout(function () {
            // window.Initial_Properties_Set();
            window.LoadingScreen_Hide();
        }, 2000);
    }, []);

    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_Register_Success",
            Component: <Subwindow_Modal_Register_RequestSent />
        }
    ]);
    const [Banner_Image, Banner_Image_Set] = useState("Tab_Banner_1");
    const [Banner_Slideshow, Banner_Slideshow_Set] = useState([
        Slideshow_1,
        Slideshow_2,
        Slideshow_3,
        Slideshow_4,
        Slideshow_5,
        Slideshow_6,
        Slideshow_7,
        Slideshow_8,
        Slideshow_9,
        Slideshow_10,
        Slideshow_11
    ]);
    const [Banner_Slideshow_Slide, Banner_Slideshow_Slide_Set] = useState(0);
    useEffect(() => {
        const slideshowTimer = setInterval(() => {
            Banner_Slideshow_Slide_Set(prevSlide => {
                return (prevSlide + 1) % Banner_Slideshow.length;
            });
        }, 15000);

        return () => {
            clearInterval(slideshowTimer);
        };
    }, [Banner_Slideshow.length]); 

    useEffect(() => {
        Banner_Image_Set(`Tab_Banner_${Banner_Slideshow_Slide}`);
    }, [Banner_Slideshow_Slide, Banner_Slideshow]);
    return (
        <>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <div className="Landing">
                <div className="Landing_Content">
                    <div className="Landing_Logo_DR" id="Landing_Logo_DR_Image" State="Active">
                        <img className="Landing_Logo_DR_Image" src={DRLogo} draggable="false" loading='lazy' alt='' />
                        <p>{Loading}</p>
                    </div>
                    
                    <div className="Landing_Form" id="Landing_Form" Form="Login">
                        <FormLandingLogin Loading={Loading} Set_Loading={Loading_Set} />
                        <FormLandingRegister Loading={Loading} Set_Loading={Loading_Set} />
                    </div>
                    <div className="Landing_Logo_RED" id="Landing_Logo_RED_Image" State="Active">
                        <img className="Landing_Logo_RED_Image" src={REDLogo} draggable="false" loading='lazy' alt=''/>
                    </div>
                    <div className="Landing_Version">
                        <p className="Landing_Version_Text">
                            Beta 1.1 January 2026
                        </p>
                    </div>
                </div>
                <div className="Landing_Banner">
                    {/* <div className='Landing_Selector'>
                        <UI_Horizontal_Tabs
                            Selectors={[
                                {
                                    Icon: <UI_Icon Name="School" />,
                                    Text: "Main building"
                                },
                                {
                                    Icon: <UI_Icon Name="School" />,
                                    Text: "Annex building"
                                }
                            ]}
                            SelectorsOnly={true}
                            UIDs={["Banner_Main", "Banner_Annex"]}
                            onChange={(e) => Banner_Image_Set(e)}
                            Selected="Tab_Banner_Main"
                        />
                    </div> */}
                    {Banner_Slideshow.map((Item, Index) => (
                        <img className="Landing_Banner_Image" src={Item} draggable="false" loading='lazy' alt='' State={Banner_Image === `Tab_Banner_${Index}` ? "Active" : "Inactive"} />
                    ))}
                    
                    {/* <img className="Landing_Banner_Image" src={Background_Annex} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Annex" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_1} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_1" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_2} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_2" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_3} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_3" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_4} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_4" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_5} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_5" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_6} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_6" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_7} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_7" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_8} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_8" ? "Active" : "Inactive"} />
                    <img className="Landing_Banner_Image" src={Slideshow_9} draggable="false" loading='lazy' alt='' State={Banner_Image === "Tab_Banner_Slideshow_9" ? "Active" : "Inactive"} /> */}
                </div>
            </div>
        </>

    )
}